<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table" *ngIf="lockingChecks?.length > 0">
          <tr class="th-plugin-line--header">
            <td colspan="4">
              <span>{{ 'plugins.locking-check.os' | translate }}</span>
            </td>
            <td colspan="4">
              <span>{{ 'plugins.locking-check.oos' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--subheader">
            <td>
              <span>N°</span>
            </td>
            <td class="th-plugin-line--value">
              <span>{{ 'plugins.locking-check.locked' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <span>{{ 'plugins.locking-check.unlock' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <span>{{ 'plugins.locking-check.locking' | translate }}</span>
            </td>
            <td>
              <span></span>
            </td>
            <td class="th-plugin-line--value">
              <span>{{ 'plugins.locking-check.locked' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <span>{{ 'plugins.locking-check.unlock' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <span>{{ 'plugins.locking-check.locking' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input" *ngFor="let item of lockingChecks; let i = index">
            <td>
              <span>{{ item.Id }}.</span>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  name="item.OsLocked-{{ i }}"
                  class="ir-form-set"
                  type="number"
                  min="0"
                  step="any"
                  [(ngModel)]="item.OsLocked"
                />
              </div>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  name="item.OsUnlock-{{ i }}"
                  class="ir-form-set"
                  type="number"
                  min="0"
                  step="any"
                  [(ngModel)]="item.OsUnlock"
                />
              </div>
            </td>
            <td class="th-plugin-line--value important">
              <span>{{ item.OsUnlock - item.OsLocked | number : '1.2-2' }}</span>
            </td>
            <td>
              <span></span>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  name="OssLocked-{{ i }}"
                  class="ir-form-set"
                  type="number"
                  min="0"
                  step="any"
                  [(ngModel)]="item.OssLocked"
                />
              </div>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  name="Ossunlock-{{ i }}"
                  class="ir-form-set"
                  type="number"
                  min="0"
                  step="any"
                  [(ngModel)]="item.Ossunlock"
                />
              </div>
            </td>
            <td class="th-plugin-line--value important">
              <span>{{ item.Ossunlock - item.OssLocked | number : '1.2-2' }}</span>
            </td>
            <td class="th-plugin-line--remove">
              <i (click)="remove(item.Id)" class="material-icons">remove_circle</i>
            </td>
          </tr>
          <tr class="th-plugin-line--add">
            <td><i (click)="add()" class="material-icons">add_circle</i></td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            (click)="save()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
